import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@/styles/styles.scss';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import ConfirmDialogComponent from '@/components/Dialogs/ConfirmDialog.component.vue';
import ConfirmRevisionDialogComponent from '@/components/Dialogs/ConfirmRevisionDialog.component.vue';
import AlertDialogComponent from '@/components/Dialogs/AlertDialog.component.vue';
import LoadingComponent from '@/components/Loading.component.vue';

Vue.config.productionTip = false;

Vue.component('ConfirmDialogComponent', ConfirmDialogComponent);
Vue.component('ConfirmRevisionDialogComponent', ConfirmRevisionDialogComponent);
Vue.component('LoadingComponent', LoadingComponent);
Vue.component('AlertDialogComponent', AlertDialogComponent);

export enum EventBusEvents {
  SelectedAllActuators = 'SelectedAllActuators',
  DeselectedAllActuators = 'DeselectedAllActuators'
}

export const customEventBus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
